import { render } from "./EditUserProfessions.vue?vue&type=template&id=5631aab8"
import script from "./EditUserProfessions.vue?vue&type=script&lang=js"
export * from "./EditUserProfessions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__